(function ($) {
  $(document).ready(function () {
  	AOS.init({
        once: true,
      	duration: 1250
    });
  	AOS.refresh();
  	$('.page-social-responsibility .section-list-middle .list-item').addClass('owl-carousel');
	$('.page-social-responsibility .section-list-middle .list-item').owlCarousel({
      loop: true,
      nav: false,
      responsive:{
        0:{
            items: 1,
          	margin: 23,
          	dots: true
        },
        575:{
            items: 2,
          	margin: 30,
          	dots: true
        },
        768: {
          	items: 2,
          	margin: 30,
          	dots: false
        },
        992:{
            items: 3,
          	margin: 40,
          	dots: false
        },
        1200:{
            items: 3,
          	margin: 60,
          	dots: false
        }
       }
    });
    $('.page-social-responsibility .section-list-middle .list-item').trigger('refresh.owl.carousel');
    
  	$('.page-social-responsibility .section-list-middle .item .item-title').matchHeight();
  	$('.page-social-responsibility .section-list-middle .item .item-content').matchHeight();
  	$('.page-social-responsibility .section-list-middle .item .item-subcontent').matchHeight();
  });
  $(window).on('resize', function(){
  	AOS.init({
        once: true,
      	duration: 1250
    });
  	AOS.refresh();
    $('.page-social-responsibility .section-list-middle .list-item').trigger('refresh.owl.carousel');
    
  	$('.page-social-responsibility .section-list-middle .item .item-title').matchHeight();
  	$('.page-social-responsibility .section-list-middle .item .item-content').matchHeight();
  	$('.page-social-responsibility .section-list-middle .item .item-subcontent').matchHeight();
    
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-title');
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-content');
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-subcontent');
  });
  $(window).change(function(){
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-title');
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-content');
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-subcontent');
  });
  $(window).on('orientationchange', function(){
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-title');
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-content');
//   	alignHeight('.page-social-responsibility .section-list-middle .item .item-subcontent');
  });
  $(window).on('load',function(){
    AOS.init({
      once: true,
      duration: 1250
    });
    AOS.refresh();
    $('.page-social-responsibility .section-list-middle .list-item').trigger('refresh.owl.carousel');
  });
  
//   function alignHeight(element){
//     $(element).css({'height':''});
//     var minHeight = '';
//     $(element).each(function(){
//       if(minHeight < $(this).outerHeight()){
//         minHeight = $(this).outerHeight();
//       }
//     })
//     if(minHeight > 0){
//       $(element).css({'height':minHeight});
//     }
//   }
})(jQuery);